import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { PageHeader } from '@ant-design/pro-layout';
import GuideEditor from 'components/GuideEditor';
import { startAddingGuide, stopAddingGuide } from 'store/guide-editor/actions';
import './style.css';
import { useNavigate } from 'react-router-dom';

function AddGuide() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(startAddingGuide());

        return () => {
            dispatch(stopAddingGuide());
        };
    }, [dispatch]);

    return (
        <div className="full-page">
            <PageHeader
                title="Add new guide"
                ghost={false}
                onBack={() => navigate('/guides')}
            />
            <GuideEditor />
        </div>
    );
}

export default AddGuide;
